module.exports = __webpack_public_path__ + "static/app-store-e1858342768fdb1a1257411c854d16eb.png";